'use client'
import Link from 'next/link'
import { usePathname, useParams } from 'next/navigation'

import { useTranslation } from 'app/i18n/client'

import AlertCircleIcon from 'public/icons/alert-circle.svg'
import ArrowRightIcon from 'public/icons/chevron-right.svg'

interface PointExpiryBannerProps {
  isAuthenticated: boolean
  isPointExpirySuccess: boolean
  within60Days?: number
}

const PointExpiryBanner: React.FunctionComponent<PointExpiryBannerProps> = ({
  isAuthenticated,
  isPointExpirySuccess,
  within60Days,
}) => {
  const { t } = useTranslation()
  const pathname = usePathname()
  const params = useParams<{ locale: string }>()
  const { locale } = params || {}

  if (pathname !== `/${locale}`) return null

  if (!isAuthenticated || !isPointExpirySuccess || !within60Days) return null

  return (
    <Link
      prefetch={false}
      href={`/${locale}/my-page/point-information`}
      className="mx-auto mt-4 flex h-12 w-[90%] items-center gap-4 border border-primary bg-primary-light p-3"
    >
      <AlertCircleIcon
        aria-hidden="true"
        className="w-6 flex-none stroke-current text-primary"
      />
      <span className="text-sm font-medium leading-[1.6] text-primary">
        {t('You have points expiring within 60 days')}
      </span>
      <ArrowRightIcon
        aria-hidden="true"
        className="ml-auto h-[9.6px] w-6 flex-none text-primary [&_path]:fill-current"
      />
    </Link>
  )
}

export default PointExpiryBanner
